import { getAnalyticsService, AnalyticsEvent } from './index';

export interface CreateEditTrackerOptions {
  contractDateId: number | string;
}

export interface EditTracker {
  trackStarted(editSource?: string): void;
  trackSaved(fieldsChanged: string[]): void;
}

export const createEditTracker = ({ contractDateId }: CreateEditTrackerOptions): EditTracker => {
  const startTime = Date.now();

  const trackStarted = (editSource?: string): void => {
    const service = getAnalyticsService();
    service.trackEvent(AnalyticsEvent.EditStarted, {
      contract_date_id: String(contractDateId),
      ...(editSource !== undefined && { edit_source: editSource }),
    });
  };

  const trackSaved = (fieldsChanged: string[]): void => {
    if (fieldsChanged.length === 0) {
      // Guard: no-op if no fields actually changed
      return;
    }
    const service = getAnalyticsService();
    service.trackEvent(AnalyticsEvent.EditSaved, {
      contract_date_id: String(contractDateId),
      fields_changed: fieldsChanged,
      fields_changed_count: fieldsChanged.length,
      duration_ms: Date.now() - startTime,
    });
  };

  return { trackStarted, trackSaved };
};
